const TOC_TOGGLE_BTN_ID = 'toc-toggle-btn';

class TocToggler {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => {
			const toggleBtn = document.getElementById(TOC_TOGGLE_BTN_ID);
			if (!toggleBtn) {
				return;
			}
			toggleBtn.addEventListener('click', e => {
				e.currentTarget.setAttribute(
					'aria-expanded',
					e.currentTarget.getAttribute('aria-expanded') === "false"
				);
			});
		});
	}
}

if (document.documentElement.clientWidth < 992) {
	new TocToggler();
}
